export { default as TypographyBlockquote } from "./typography-blockquote";
export { default as TypographyDescription } from "./typography-description";
export { default as TypographyFirm } from "./typography-firm";
export { default as TypographyH1 } from "./typography-h1";
export { default as TypographyH2 } from "./typography-h2";
export { default as TypographyH3 } from "./typography-h3";
export { default as TypographyH4 } from "./typography-h4";
export { default as TypographyLarge } from "./typography-large";
export { default as TypographyP } from "./typography-p";
export { default as TypographySmall } from "./typography-small";
